import { Modal } from './ui.tsx';
import { LineChart } from './Charts.tsx';
import { formatDate, formatNumber } from '../lib/format.ts';
import type { CompetitorWithHistory } from '../../../shared/types.ts';

/** Visualização rápida do histórico de um concorrente — o dado já vem
 * junto na listagem (snapshots por rodada de auditoria), só faltava um
 * jeito de ver a evolução sem sair da tabela. */
export function CompetitorDetailModal({
  competitor,
  onClose,
}: {
  competitor: CompetitorWithHistory;
  onClose: () => void;
}) {
  const points = competitor.snapshots
    .filter((s) => s.followers !== null)
    .map((s) => ({ date: s.capturedAt, value: s.followers as number }));

  return (
    <Modal title={`${competitor.handle} — ${competitor.name}`} onClose={onClose}>
      <div className="stack">
        <p className="text-micro text-muted">
          <a
            className="link"
            href={competitor.profileUrl ?? '#'}
            target="_blank"
            rel="noreferrer noopener"
          >
            Ver perfil no Instagram
          </a>
        </p>

        {points.length > 1 ? (
          <LineChart points={points} label="Seguidores por rodada" />
        ) : (
          <p className="text-muted text-label">
            Só uma rodada de auditoria coletada até agora — sem histórico pra mostrar tendência.
          </p>
        )}

        <table className="table">
          <thead>
            <tr>
              <th>Rodada</th>
              <th className="align-right">Seguidores</th>
              <th className="align-right">Publicações</th>
              <th className="align-right">Engajamento</th>
            </tr>
          </thead>
          <tbody>
            {[...competitor.snapshots].reverse().map((s) => (
              <tr key={s.id}>
                <td className="text-muted tabular-nums">{formatDate(s.capturedAt)}</td>
                <td className="align-right tabular-nums">
                  {s.followers === null ? '—' : formatNumber(s.followers)}
                </td>
                <td className="align-right tabular-nums">
                  {s.postsCount === null ? '—' : formatNumber(s.postsCount)}
                </td>
                <td className="align-right tabular-nums">
                  {s.engagementRate === null ? '—' : `${(s.engagementRate * 100).toFixed(1)}%`}
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {competitor.notes && <p className="text-body text-muted">{competitor.notes}</p>}
      </div>
    </Modal>
  );
}
